import { Avatar, createStyles, Divider, List, ListItem, ListItemAvatar, ListItemText, makeStyles, Theme, Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import { Delete as DeleteIcon, Edit as UpdateIcon } from '@material-ui/icons';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ReelsCategory } from '../../../interfaces/tell_me_watch/reelsCategory.types';
import { AppState } from '../../../store/store';
import ReelsCategoryDeleteDialog from './Delete_Dialog';
import ReelsCategoryUpdateDialog from './Update_Dialog';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        list: {
            backgroundColor: theme.palette.background.paper,
            position: 'relative',
            overflow: 'auto',
            padding: 15,
            maxHeight: '80%',
        },
        root: {
            padding: 10,
            margin: 25,
            minWidth: 1200,
        },
        listSection: {
            backgroundColor: 'inherit',
        },
        ul: {
            backgroundColor: 'inherit',
            padding: 0,
        },
    }),
);

export default function ReelsCategoriesScreen() {

    const classes = useStyles();
    const categories = useSelector((state: AppState) => state.reelsCategories);

    // Dialog variables
    const [selectedCategory, setSelectedCategory] = useState<ReelsCategory>();
    const [openUpdateDialog, setUpdateDialog] = useState(false);
    const [openDeleteDialog, setDeleteDialog] = useState(false);

    return (
        <div style={{ paddingBottom: 150, }}>
            <Paper className={classes.root}>

                <h2>Reels Categories</h2>

                <Box />

                <List className={classes.list} >
                    {
                        categories.map((category) => {

                            return (<ListItem id={category.id}>
                                <ListItemAvatar>
                                    <Avatar onClick={() => {
                                        setSelectedCategory(category);
                                        setUpdateDialog(true);
                                    }}>
                                        <UpdateIcon />
                                    </Avatar>
                                </ListItemAvatar>

                                <ListItemAvatar>
                                    <Avatar onClick={() => {
                                        setSelectedCategory(category);
                                        setDeleteDialog(true);
                                    }}>
                                        <DeleteIcon />
                                    </Avatar>
                                </ListItemAvatar>

                                <ListItemText primary={category.name} secondary={" id: " + category.id} />
                                <Typography>
                                    {" Reels Count: " + category.reels.length}
                                </Typography>
                                <Typography>
                                    {", isPremium: " + category.isPremium}
                                </Typography>
                                <Typography>
                                    {", isActive: " + category.isActive}
                                </Typography>
                                <Typography>
                                    {", isDefault: " + category.isDefault}
                                </Typography>
                                <Typography>
                                    {", lastUpdatedTime: " + new Date(category.lastUpdatedTime ?? 0).toUTCString()}
                                </Typography>
                                <Typography>
                                    {", index: " + category.index + " "}
                                </Typography>
                                <img style={{ width: 120, margin: 15, }} src={category.image} alt={category.name} />
                                <Divider />
                            </ListItem>
                            );
                        })
                    }

                </List>
            </Paper>

            {
                selectedCategory ?
                    <>
                        <ReelsCategoryDeleteDialog
                            category={selectedCategory}
                            open={openDeleteDialog}
                            handleClose={() => setDeleteDialog(false)}
                        />
                        <ReelsCategoryUpdateDialog
                            category={selectedCategory}
                            open={openUpdateDialog}
                            handleClose={() => setUpdateDialog(false)}
                        />
                    </>
                    :
                    <>
                    </>
            }
        </div >
    );

}